import { type FC, type ComponentProps } from "react";
import { AppPromotion } from "@userFrontend/features/promotion/components/AppPromotion";
import { RecommendWorks } from "@userFrontend/features/promotion/components/RecommendWorks";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { type GraphCassetteProps, type GenreResult } from "./type";
import { XShareLink } from "./uiParts/XShareLink";
import { ResultDetail } from "./uiParts/ResultDetail";
import { GraphCassettes } from "./uiParts/GraphCassettes";
import { Header } from "../Header";
import { Footer } from "../Footer";
import * as styles from "./styles.css";

export type PresentationProps = {
  businessTypeName: string;
  location: string;
  title: string;
  genreResults: GenreResult[];
  graphCassetteProps: GraphCassetteProps[];
  shareUrl: string;
  appPromotionPath: string;
  recommendWorks: ComponentProps<typeof RecommendWorks>[];
  hasRecommendWorks: boolean;
  showCampaignBanner: boolean;
};

export const Presentation: FC<PresentationProps> = ({
  businessTypeName,
  location,
  title,
  genreResults,
  graphCassetteProps,
  shareUrl,
  appPromotionPath,
  recommendWorks,
  hasRecommendWorks,
  showCampaignBanner,
}) => {
  return (
    <>
      <Header />
      <div className={styles.assessmentResultContainer} data-ga-action="assess_result__first_view">
        <ResultDetail title={title} results={genreResults} />
        {showCampaignBanner ? (
          <div className={styles.xShareLinkCampaignWrapper}>
            <LazyLoadImage
              src="/images/user_frontend/landing/assessment/amazon-gift-campaign-banner.png"
              width={328}
              height={64}
              alt="Amazonギフト券1000円分プレゼント!2026年4月17日(金)〜2026年7月17日(金)"
            />
            <p className={styles.xShareLinkCampaignText}>
              「Xでシェアする」から、
              <span className={styles.xShareLinkCampaignHashtag}>#リジョブ #売上力診断</span>{" "}
              をつけて投稿してください。
              <br />
              ※当選時は投稿アカウントにDMにてご連絡いたします。
            </p>
            <XShareLink shareUrl={shareUrl} />
          </div>
        ) : (
          <div className={styles.xShareLinkWrapper}>
            <p className={styles.xShareText}>＼診断結果をシェアしましょう／</p>
            <XShareLink shareUrl={shareUrl} />
          </div>
        )}
      </div>
      <div className={styles.assessmentDetailContainer}>
        <p className={styles.assessmentDetailTitle}>診断結果の詳細</p>
        <GraphCassettes resultDetails={graphCassetteProps} className={styles.graphCassette} />
        {hasRecommendWorks && (
          <>
            <p className={styles.assessmentDetailTitle}>
              あなたの<span className={styles.highlightText}>売上UP</span>に直結する求人
            </p>
            <p className={styles.recommendWorksInfo}>
              {location} / {businessTypeName}
            </p>
            {recommendWorks.map((recommendWork) => (
              <div key={recommendWork.title} className={styles.recommendWorksWrapper}>
                <RecommendWorks {...recommendWork} />
              </div>
            ))}
          </>
        )}
        <AppPromotion path={appPromotionPath} className={styles.appPromotion} />
      </div>
      <Footer />
    </>
  );
};
